import './theme.d';

import { SxProps, Theme, createTheme } from '@mui/material/styles';

export const applicationTheme = createTheme({
  palette: {
    primary: {
      main: '#0d1a58',
    },
    secondary: {
      main: '#000',
    },
    warning: {
      main: '#f2ae43',
      contrastText: '#fff',
    },
    error: {
      main: '#db524c',
    },
    success: {
      main: '#59b959',
      contrastText: '#fff',
    },
    background: {
      default: '#f8f8f8',
    },
    blue: {
      light: '#63a2d7',
      main: '#3d8bcd',
      dark: '#306fa4',
      contrastText: '#fff',
    },
    darkGray: {
      light: '#8d8d8d',
      main: '#717171',
      dark: '#5a5a5a',
      contrastText: '#fff',
    },
    lightGrey: {
      light: '#ededed',
      main: '#e9e9e9',
      dark: '#bababa',
      contrastText: '#6f6f6f',
    },
  },
  typography: {
    h2: {
      fontSize: '27px',
      fontWeight: '800',
    },
    h3: {
      fontSize: '24px',
      fontWeight: '700',
    },
    h4: {
      fontSize: '20px',
      fontWeight: '700',
    },
    h5: {
      fontSize: '16px',
      fontWeight: '600',
      color: 'black',
    },
    h6: {
      fontSize: '14px',
      fontWeight: '600',
      color: 'black',
    },
    fontFamily: 'Red Hat Text, Arial, sans-serif',
  },
});

export enum CustomPaletteColor {
  Primary = 'primary',
  Secondary = 'secondary',
  Error = 'error',
  Success = 'success',
  Warning = 'warning',
  DarkGray = 'darkGray',
  Blue = 'blue',
  LightGrey = 'lightGrey',
  Background = 'background',
}

export type CustomPaletteColorType = CustomPaletteColor | undefined;

export const ActionButtonStyle: SxProps<Theme> = {
  textTransform: 'none',
  fontSize: '12px',
  ml: '10px',
};
